import { CountryLanguageCodes } from '@nx-customer-apps/shared/enums';
import { CountryLangugePair } from '@nx-customer-apps/shared/interfaces';

export const CountryLanguagePairs: CountryLangugePair[] = [
    { key: 'deDE', locale: CountryLanguageCodes.deDE },
    { key: 'enDE', locale: CountryLanguageCodes.enDE }
];
